function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Object, String, countryCode, editing, inputValue, isFile, isSwitch, localPhoneNumber, password1, password2, removable, saveDisabled, saving, selectItems, selectMenuOpen, selectTagOpen, selectedTags, selectedValue, switchOn, uploading, validationError) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const disabled = $attr(`disabled`);;
    let saveableInput = true;;
    let emptiable = false;;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'mp-settings-li-disabled': disabled,
          'mp-settings-li-editing': editing,
          'mp-settings-li-select': $component.isSelect,
          'mp-settings-li-uploading': uploading,
        }, {
          'mp-settings-li': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-settings-li-label': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("p", [__vjadeSafeCode($helpers.label())]));
          __jade_nodes = __jade_nodes.concat(($attr('info')) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'icon-btn': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": {
                  placement: `top`,
                  type: `default`,
                  'always-show': false
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode($attr('info'))]));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-settings-li-label-icon': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": {
                    icon: `info`
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-settings-li-value-cont': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(((($helpers.inputType()) == (`text`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": {
                  readonly: disabled || !editing || saving,
                  placeholder: $attr(`placeholder`),
                  type: `text`,
                },
                "props": {
                  value: inputValue
                },
                "on": {
                  input: $helpers.inputUpdated,
                  keydown: $helpers.handleKeydown
                },
                "hook": {
                  insert: $helpers.inputInserted
                },
                "class": {
                  'remove-chrome-form-style': true
                },
              }));
              __jade_nodes = __jade_nodes.concat((validationError) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": {
                    'always-show': true,
                    type: `error`
                  },
                }, [__vjadeSafeCode(validationError)]));;
                return __jade_nodes
              }).call(this)) : undefined);
              emptiable = $attr(`emptiable`);;
              saveableInput = !!inputValue || emptiable;;;
              return __jade_nodes
            }).call(this)) :
            ((($helpers.inputType()) == (`password`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": {
                  disabled: disabled || !editing || saving,
                  placeholder: `New password`,
                  type: `password`,
                },
                "props": {
                  value: editing ? password1 : inputValue
                },
                "on": {
                  input: ev => $helpers.passwordUpdated(1, ev)
                },
                "hook": {
                  insert: $helpers.inputInserted
                },
                "class": {
                  'remove-chrome-form-style': true
                },
              }));
              __jade_nodes = __jade_nodes.concat((editing) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("input", {
                  "attrs": {
                    disabled: disabled || saving,
                    placeholder: `Confirm password`,
                    type: `password`,
                  },
                  "props": {
                    value: password2
                  },
                  "on": {
                    input: ev => $helpers.passwordUpdated(2, ev)
                  },
                  "class": {
                    'remove-chrome-form-style': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);
              saveableInput = !!password1 && password1 === password2;;;
              return __jade_nodes
            }).call(this)) :
            ((($helpers.inputType()) == (`tag`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((editing || saving) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-settings-li-menu': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-settings-li-menu-container': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                      "attrs": {
                        open: selectTagOpen
                      },
                      "on": {
                        change: $helpers.handleTagMenuChange
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tag-selector", {
                        "attrs": {
                          'options': JSON.stringify($helpers.getTagOptions()),
                          'saving': saving,
                          'input-text': JSON.stringify({
                            search: 'Search tags...',
                            empty: 'No tags found',
                            create: 'Create new tag:'
                          }),
                          'min-tags': 0,
                        },
                        "on": {
                          save: $helpers.clickedSave,
                          change: $helpers.tagSelectorChanged,
                        },
                        "hook": {
                          insert: $helpers.inputInserted,
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                const tags = Array.from(selectedTags);;
                __jade_nodes = __jade_nodes.concat((tags.length) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-settings-li-menu-tags-container': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((function() {
                      var $$obj = (tags);
                      var $$eachNodes;
                      var $$iterated = false;
                      if (Array.isArray($$obj)) {
                        $$eachNodes = $$obj.reduce(function($$eachNodes, tagName, $index) {
                          $$iterated = true;
                          return $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tag", {
                              "attrs": {
                                'size': `small`,
                                'tag-name': tagName,
                                'theme': `light`,
                                clickable: false,
                                removable: false,
                              },
                            }));;
                            return __jade_nodes
                          }).call(this));
                        }, []);
                      } else {
                        $$eachNodes = [];
                        for (var $$objKey in $$obj) {
                          (function() {
                            var $index = $$objKey;
                            if ($$obj.hasOwnProperty($index)) {
                              $$iterated = true;
                              var tagName = $$obj[$index];
                              $$eachNodes = $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-tag", {
                                  "attrs": {
                                    'size': `small`,
                                    'tag-name': tagName,
                                    'theme': `light`,
                                    clickable: false,
                                    removable: false,
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this));
                            }
                          })();
                        }
                      }

                      return $$eachNodes;
                    })());;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this)) :
            ((($helpers.inputType()) == (`select`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((editing || saving) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-settings-li-menu': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                    "attrs": {
                      size: `small`
                    },
                    "on": {
                      click: $helpers.toggleSelectMenu
                    },
                    "class": {
                      'mp-button-secondary': true,
                      'settings-li-select-button': true
                    },
                  }, [__vjadeSafeCode(selectedValue.label)]));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-settings-li-menu-container': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                      "attrs": {
                        open: selectMenuOpen
                      },
                      "on": {
                        change: $helpers.handleSelectMenuChange
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                        "attrs": {
                          sections: JSON.stringify([{
                            items: selectItems
                          }])
                        },
                        "on": {
                          clickItem: $helpers.selectItem
                        },
                        "class": {
                          'mp-settings-li-menu-list': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("input", {
                  "attrs": {
                    disabled: true,
                    type: `text`
                  },
                  "props": {
                    value: selectedValue.label
                  },
                  "hook": {
                    insert: $helpers.inputInserted
                  },
                  "class": {
                    'remove-chrome-form-style': true
                  },
                }));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this)) :
            ((($helpers.inputType()) == (`file`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": {
                  disabled: true,
                  type: `text`
                },
                "props": {
                  value: inputValue
                },
                "class": {
                  'remove-chrome-form-style': true
                },
              }));;
              return __jade_nodes
            }).call(this)) :
            ((($helpers.inputType()) == (`phone-number`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": {
                  disabled: disabled || !editing || saving,
                  placeholder: editing ? `+1` : `+1 (415) 123-1322`,
                  type: `text`,
                  name: editing ? `country-code` : `formatted-phone`,
                },
                "props": {
                  value: editing ? $helpers.parsePhoneNumber(inputValue).countryCode : inputValue
                },
                "on": {
                  input: ev => $helpers.phoneNumberUpdated(ev)
                },
                "hook": {
                  insert: $helpers.inputInserted
                },
                "class": {
                  'remove-chrome-form-style': true
                },
              }));
              __jade_nodes = __jade_nodes.concat((editing) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("input", {
                  "attrs": {
                    disabled: disabled || saving,
                    placeholder: `(415) 123-1322`,
                    type: `text`,
                    name: `local-phone-number`,
                  },
                  "props": {
                    value: $helpers.parsePhoneNumber(inputValue).localPhoneNumber
                  },
                  "on": {
                    input: ev => $helpers.phoneNumberUpdated(ev)
                  },
                  "class": {
                    'remove-chrome-form-style': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((validationError) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": {
                    'always-show': true,
                    type: `error`
                  },
                }, [__vjadeSafeCode(validationError)]));;
                return __jade_nodes
              }).call(this)) : undefined);
              saveableInput = !!localPhoneNumber && !!countryCode;;;
              return __jade_nodes
            }).call(this)) :
            ((($helpers.inputType()) == (`slot`))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("slot"));;
              return __jade_nodes
            }).call(this)) :
            undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-settings-li-button': true
            },
          }, (function() {
            var __jade_nodes = [];
            const buttonText = $attr(`button`);;
            const isDeleteButton = $attr(`delete-button`);;
            __jade_nodes = __jade_nodes.concat((isSwitch) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-switch", {
                "attrs": {
                  on: switchOn
                },
                "on": {
                  change: $helpers.switchChanged
                },
              }));;
              return __jade_nodes
            }).call(this)) : (isFile) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((uploading) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((removable) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                    "attrs": {
                      theme: `tertiary`,
                      icon: `trashcan`,
                      destructive: `true`
                    },
                    "on": {
                      click: $helpers.clickedRemove
                    },
                  }));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    size: `small`,
                    disabled: saving
                  },
                  "on": {
                    click: $helpers.stopUploading
                  },
                  "class": {
                    'mp-button-secondary': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Cancel");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    size: `small`,
                    disabled: saving
                  },
                  "on": {
                    click: $helpers.clickedUpload
                  },
                  "class": {
                    'mp-button-primary': true,
                    'mp-settings-li-file-save-button': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("" + ($attr(`buttontext`)) + "");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("input", {
                  "attrs": {
                    type: `file`,
                    accept: $attr(`fileaccept`)
                  },
                  "on": {
                    change: $helpers.fileDialogEnded
                  },
                  "hook": {
                    insert: $helpers.fileInserted
                  },
                  "class": {
                    'mp-settings-li-hidden': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    theme: `tertiary`,
                    icon: `edit`
                  },
                  "on": {
                    click: $helpers.uploadFile
                  },
                }));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this)) : (editing && !$attr(`hide-buttons`)) ? ((function() {
              var __jade_nodes = [];
              const saveHandler = $attr(`custom-handling`) ? $helpers.customSave : $helpers.clickedSave;;
              const cancelHandler = $attr(`custom-handling`) ? $helpers.customCancel : $helpers.stopEditing;;
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  size: `small`,
                  disabled: saving
                },
                "on": {
                  click: cancelHandler
                },
                "class": {
                  'mp-button-secondary': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Cancel");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  size: `small`,
                  disabled: saving || !saveableInput || saveDisabled
                },
                "on": {
                  click: saveHandler
                },
                "class": {
                  'mp-button-primary': true,
                  'mp-settings-li-save-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((saving) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
                    "attrs": {
                      color: `white`
                    },
                  }));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Save");;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : (!editing && $attr(`editable`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  theme: `tertiary`,
                  icon: `edit`
                },
                "on": {
                  click: $helpers.startEditing
                },
              }));;
              return __jade_nodes
            }).call(this)) : (buttonText) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  disabled,
                  theme: `secondary`,
                  destructive: isDeleteButton,
                  icon: isDeleteButton ? `trashcan` : ``,
                  size: `small`,
                },
                "on": {
                  click: $helpers.clickedButton
                },
              }, [__vjadeSafeCode(buttonText)]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "countryCode" in locals ? locals.countryCode : typeof countryCode !== "undefined" ? countryCode : undefined, "editing" in locals ? locals.editing : typeof editing !== "undefined" ? editing : undefined, "inputValue" in locals ? locals.inputValue : typeof inputValue !== "undefined" ? inputValue : undefined, "isFile" in locals ? locals.isFile : typeof isFile !== "undefined" ? isFile : undefined, "isSwitch" in locals ? locals.isSwitch : typeof isSwitch !== "undefined" ? isSwitch : undefined, "localPhoneNumber" in locals ? locals.localPhoneNumber : typeof localPhoneNumber !== "undefined" ? localPhoneNumber : undefined, "password1" in locals ? locals.password1 : typeof password1 !== "undefined" ? password1 : undefined, "password2" in locals ? locals.password2 : typeof password2 !== "undefined" ? password2 : undefined, "removable" in locals ? locals.removable : typeof removable !== "undefined" ? removable : undefined, "saveDisabled" in locals ? locals.saveDisabled : typeof saveDisabled !== "undefined" ? saveDisabled : undefined, "saving" in locals ? locals.saving : typeof saving !== "undefined" ? saving : undefined, "selectItems" in locals ? locals.selectItems : typeof selectItems !== "undefined" ? selectItems : undefined, "selectMenuOpen" in locals ? locals.selectMenuOpen : typeof selectMenuOpen !== "undefined" ? selectMenuOpen : undefined, "selectTagOpen" in locals ? locals.selectTagOpen : typeof selectTagOpen !== "undefined" ? selectTagOpen : undefined, "selectedTags" in locals ? locals.selectedTags : typeof selectedTags !== "undefined" ? selectedTags : undefined, "selectedValue" in locals ? locals.selectedValue : typeof selectedValue !== "undefined" ? selectedValue : undefined, "switchOn" in locals ? locals.switchOn : typeof switchOn !== "undefined" ? switchOn : undefined, "uploading" in locals ? locals.uploading : typeof uploading !== "undefined" ? uploading : undefined, "validationError" in locals ? locals.validationError : typeof validationError !== "undefined" ? validationError : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;